// src/Sidebar.js
import React from "react";
import styles from "./style.module.css"; // We'll add some CSS later

const Navbar = () => {
  return <nav className={styles.navbar}></nav>;
};

export default Navbar;
